<template>
  <div class="analyse-line-chart">
    <!--折线图-->
    <LineChart
      :title="title"
      :titleStyle="{ fontSize: '18px' }"
      height="250px"
      :fields="fields"
      :dataSource="dataSource"
    />
    <!--分析-->
    <div class="flex-between analyse-row" style="margin-top: 20px">
      <div class="analyse-card" style="width: calc(50% - 15px)">
        <div class="flex-align-center" style="margin-bottom: 10px">
          <img
            src="@/assets/imgs/school/monthRecord/analyse.png"
            alt=""
            style="width: 14px; height: 14px; margin-right: 5px"
          />
          <span>趋势分析：</span>
        </div>
        <div v-if="analyseList.length" class="analyse-list">
          <div
            v-for="(item, index) in analyseList"
            :key="index"
            class="analyse-item"
            v-html="item"
          ></div>
        </div>
        <EmptyData v-else />
        <!-- <div class="trend-content">
          从情绪指数变化曲线可以清晰地看出，全校情绪指数最高点为2026年4月8日的29.16，最低点出现在2025年11月28日的13.15，整体心理状态积极平稳，校园心理健康氛围向好发展。
        </div> -->
      </div>
      <div class="analyse-card" style="width: calc(50% - 15px)">
        <div class="flex-between" style="margin-bottom: 10px">
          <div class="flex-align-center">
            <img
              src="@/assets/imgs/school/monthRecord/rank.png"
              alt=""
              style="width: 14px; height: 14px; margin-right: 5px"
            />
            <span>年级情绪排名：</span>
          </div>
          <span class="sub-title-avg">全校情绪均值：{{ schoolAvg }}</span>
        </div>
        <!-- 年级排名列表 -->
        <div v-if="gradeRankList.length" class="grade-rank-list">
          <div
            v-for="(item, index) in gradeRankList"
            :key="item.gradeName"
            class="grade-rank-item"
          >
            <span class="rank-badge" :class="`rank-${index + 1}`">{{ index + 1 }}</span>
            <span class="grade-name">{{ item.gradeName }}</span>
            <span class="grade-avg">情绪指数均值：{{ item.avg }}</span>
            <span class="grade-diff">
              {{ item.diffText }}
            </span>
          </div>
        </div>
        <EmptyData v-else />
        <!-- <div v-if="analyseList.length" class="analyse-list">
          <div
            v-for="(item, index) in analyseList"
            :key="index"
            class="analyse-item"
            v-html="item"
          ></div>
        </div>
        <EmptyData v-else /> -->
      </div>
    </div>
  </div>
</template>
<script>
import LineChart from '@/components/echartZyz/components/LineChart'
import { getGradeEmotionTrendRanking } from '@api/monthReport'
export default {
  name: 'AnalyseLineChart',
  components: {
    LineChart,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    // 报告时间范围（用于请求年级情绪排名）
    dateRange: {
      type: Object,
      default: () => ({}),
    },
    // 数据源
    dataSource: {
      type: Array,
      default: () => [],
    },
    // 图例
    fields: {
      type: Array,
      default: () => [],
    },
    // 趋势分析文本
    analyseList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      schoolMood: [],
      moodField: [],
      queryParam: {},
      loadingChart: false,
      // 全校情绪均值
      schoolAvg: '-',
      // 年级情绪排名
      gradeRankList: [],
    }
  },
  watch: {
    dateRange: {
      immediate: true,
      handler(dateObj) {
        if (dateObj && dateObj.beginDate) {
          this.fetchGradeRank({
            startTime: dateObj.beginDate,
            endTime: dateObj.endDate,
          })
        }
      },
    },
  },
  methods: {
    // 年级情绪趋势排名
    async fetchGradeRank(params) {
      const { success, result } = await getGradeEmotionTrendRanking(params)
      if (success && result) {
        this.schoolAvg = result.schoolAvgEmotion
        this.gradeRankList = (result.gradeList || []).map((item) => ({
          gradeName: item.gradeName,
          avg: item.avgEmotion,
          diffText: item.diffText
        }))
      }
    },
  },
}
</script>

<style scoped lang="less">
.analyse-line-chart {
  // 覆盖全局 flex-between 的 align-items: center，让左右卡片拉伸等高
  .analyse-row {
    align-items: stretch !important;
    .analyse-card {
      height: auto;
    }
  }

  .analyse-card {
    padding: 20px;
    border-radius: 10px;
    background-color: #f9fafb;
    .analyse-list {
      line-height: 2;
      .analyse-item {
        letter-spacing: 0.5px;
        &:before {
          content: '';
          display: inline-block;
          width: 5px;
          height: 5px;
          margin-right: 10px;
          border-radius: 50%;
          background-color: #383838;
          vertical-align: middle;
        }
      }
    }
    .trend-content{
      font-size: 14.04px;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
    }
    .sub-title-avg{
      font-size: 14px;
      font-weight: 500;
      line-height: 24px;
      color: rgba(51, 51, 51, 1);

    }
    // 年级情绪排名列表
    .grade-rank-list {
      .grade-rank-item {
        display: flex;
        align-items: center;
        padding: 10px 0;
        .rank-badge {
          flex-shrink: 0;
          width: 18px;
          height: 18px;
          margin-right: 40px;
          // 默认：第4名及以后 灰底黑字
          color: rgba(0, 0, 0, 0.65);
          background-color: #f0f0f0;
          font-size: 12px;
          line-height: 18px;
          text-align: center;
          border-radius: 50%;
          // 前3名：彩底白字
          &.rank-1 {
            color: #fff;
            background-color: #5bbe7a;
          }
          &.rank-2 {
            color: #fff;
            background-color: #13c2c2;
          }
          &.rank-3 {
            color: #fff;
            background-color: #1890ff;
          }
        }
        .grade-name {
          flex: 1;
          color: #262626;
        }
        .grade-avg {
          flex-shrink: 0;
          width: 190px;
          color: #262626;
          font-variant-numeric: tabular-nums;
          text-align: left;
        }
        .grade-diff {
          flex-shrink: 0;
          width: 140px;
          color: rgba(58, 152, 246, 1);
          font-weight: 700;
          font-variant-numeric: tabular-nums;
          text-align: right;
        }
      }
    }
  }
}
</style>
